import { Injectable } from '@angular/core'
import {
  HttpClient
} from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class AgentService {
  url: string | null = null
  sideUrl: string | null = null
  constructor (private http: HttpClient) {
    this.url = environment.baseApiUrl + 'admin/'
    this.sideUrl = this.getSide() + 'admin/' // For All conditions Test
  }

  getSide () {
    if (
      localStorage.getItem('title') &&
      localStorage.getItem('title') === 'Test'
    ) {
      // return 'http://localhost:8000/v1/';
      return 'https://test.icashremit.com/v1/'
    }
    return 'https://api.icashremit.com/v1/'
    // return 'http://localhost:8080/v1/';
  }

  get () {
    return this.http.get(environment.baseApiUrl + 'agents').pipe(
      map((response: any) => {
        return response['data']
      })
    )
  }

  getTest () {
    return this.http.get(environment.baseApiUrlTest + 'agentTest').pipe(
      map((response: any) => {
        return response['data']
      })
    )
  }

  getAgent (slug: string): Observable<any> {
    return this.http.get(environment.baseApiUrl + 'agent/' + slug).pipe(
      map((response: any) => {
        return response['data']
      })
    )
  }
  getTestAgent (id: string): Observable<any> {
    return this.http.get(environment.baseApiUrlTest + 'agent/' + id).pipe(
      map((response: any) => {
        return response['data']
      })
    )
  }
  getAgentTransaction (agentSlug: string): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'agent_transaction/' + agentSlug
          : environment.baseApiUrlTest + 'agent_transaction/' + agentSlug
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  filter (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'agents/filter'
          : environment.baseApiUrlTest + 'agents/filter',
        data
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  addAgent (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'agent/register'
          : environment.baseApiUrlTest + 'agent/register',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }
  addAgentToLive (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'agent/register'
          : environment.baseApiUrlTest + 'agent/register',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }
  changeStatus (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'agent/status'
          : environment.baseApiUrlTest + 'agent/status',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  changeTestEnv (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'agent/env_change'
          : environment.baseApiUrlTest + 'agent/env_change',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  existsEmail (email: { email: string } | string): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'agent/email_exist'
          : environment.baseApiUrlTest + 'agent/email_exist',
        email
      )
      .pipe(
        map((response: any) => {
          return response['status']
        })
      )
  }

  updateWebHook (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'agent/update_hook'
          : environment.baseApiUrlTest + 'agent/update_hook',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }
}
